import { WebsiteResponse, SourceType } from "@authory-packages/core";

export const getSourceStatus = (sources: WebsiteResponse[], types: SourceType[]) => {
    const src = sources.filter((source) => types.includes(source.type));
    const hasSrc = !!src.length;
    const srcInProgress = hasSrc && src.every((source) => source.inProgress);

    return { hasSrc, srcInProgress };
};
